export default "/images/ico-draft.svg?267ad56e20f48429de23c1bfb44f11ef";